import { EmptyState, SectionHeader } from '@renderer/shared/components/primitives';
import { useI18n } from '@renderer/shared/i18n';

export function DomainPlaceholderScreen({ labelKey }: { labelKey: string }): JSX.Element {
  const { t } = useI18n();
  const label = t(labelKey);

  return (
    <div className="av-page">
      <SectionHeader title={label} subtitle={t('placeholder.description')} />
      <EmptyState title={t('placeholder.title', { label })} description={t('placeholder.description')} />
    </div>
  );
}
